const uuidv4 = () => {
    // @ts-ignore
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => {
        const randomValues = crypto.getRandomValues(new Uint8Array(1));
        const result = ((c ^ randomValues[0]) & 15) >> (c / 4);
        return result.toString(16);
    });
}

export const KeySolver = () => {
    return 'key_' + uuidv4();
}
